import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDragScroll]',
  standalone: true,
})
export class DragScrollDirective {
  private _isDown = false;
  private _startX = 0;
  private _startY = 0;
  private _scrollLeft = 0;
  private _scrollTop = 0;
  private _moved = false;

  constructor(
    private _el: ElementRef,
    private _renderer: Renderer2,
  ) {
    this._renderer.setStyle(this._el.nativeElement, 'overflow', 'auto');
    this._renderer.setStyle(this._el.nativeElement, 'cursor', 'grab');
  }

  @HostListener('mousedown', ['$event'])
  private onMouseDown(e: MouseEvent) {
    this._isDown = true;
    this._moved = false;
    this._startX = e.pageX - this._el.nativeElement.offsetLeft;
    this._startY = e.pageY - this._el.nativeElement.offsetTop;
    this._scrollLeft = this._el.nativeElement.scrollLeft;
    this._scrollTop = this._el.nativeElement.scrollTop;
    this._renderer.setStyle(this._el.nativeElement, 'cursor', 'grabbing');

    window.addEventListener('mouseup', () => this.onMouseUp(), { once: true });
  }

  // @HostListener('mouseup')
  private onMouseUp() {
    this._isDown = false;
    this._renderer.setStyle(this._el.nativeElement, 'cursor', 'grab');

    if (this._moved) {
      const blockClick = (e: Event) => {
        e.stopPropagation();
        e.preventDefault();
        window.removeEventListener('click', blockClick, true);
      };
      window.addEventListener('click', blockClick, true);
    }
  }

  @HostListener('mousemove', ['$event'])
  private onMouseMove(e: MouseEvent) {
    if (!this._isDown) return;
    const x = e.pageX - this._el.nativeElement.offsetLeft;
    const y = e.pageY - this._el.nativeElement.offsetTop;
    const walkX = x - this._startX;
    const walkY = y - this._startY;

    if (Math.abs(walkX) > 5 || Math.abs(walkY) > 5) {
      this._moved = true;
    }

    this._el.nativeElement.scrollLeft = this._scrollLeft - walkX;
    this._el.nativeElement.scrollTop = this._scrollTop - walkY;
  }

  @HostListener('touchstart', ['$event'])
  private onTouchStart(e: TouchEvent) {
    this._isDown = true;
    this._moved = false;
    this._startX = e.touches[0].pageX - this._el.nativeElement.offsetLeft;
    this._startY = e.touches[0].pageY - this._el.nativeElement.offsetTop;
    this._scrollLeft = this._el.nativeElement.scrollLeft;
    this._scrollTop = this._el.nativeElement.scrollTop;

    window.addEventListener('touchend', (e) => this.onTouchEnd(e), {
      once: true,
    });
  }

  // @HostListener('touchend', ['$event'])
  private onTouchEnd(e: TouchEvent) {
    this._isDown = false;

    if (this._moved) {
      if (e.cancelable) e.preventDefault();
      e.stopPropagation();

      const blockClick = (ev: Event) => {
        ev.stopPropagation();
        ev.preventDefault();
        window.removeEventListener('click', blockClick, true);
      };
      window.addEventListener('click', blockClick, true);

      setTimeout(() => {
        window.removeEventListener('click', blockClick, true);
      }, 400);
    }
  }

  @HostListener('touchmove', ['$event'])
  private onTouchMove(e: TouchEvent) {
    if (!this._isDown) return;

    const x = e.touches[0].pageX - this._el.nativeElement.offsetLeft;
    const y = e.touches[0].pageY - this._el.nativeElement.offsetTop;
    const walkX = x - this._startX;
    const walkY = y - this._startY;

    if (Math.abs(walkX) > 5 || Math.abs(walkY) > 5) {
      this._moved = true;
    }

    this._el.nativeElement.scrollLeft = this._scrollLeft - walkX;
    this._el.nativeElement.scrollTop = this._scrollTop - walkY;
  }
}
